import clsx from 'clsx'

import PercentChange from 'components/PercentChange'

import s from './StatProgress.module.css'

type Props = {
  title: string
  value?: number
  change?: number
  percent?: number
  isActive?: boolean
}

const StatProgress = ({ change, title, value, percent, isActive }: Props) => {
  const formattedValue =
    value &&
    new Intl.NumberFormat('en-US', {
      notation: 'compact',
      compactDisplay: 'short',
    }).format(value)

  const formattedPercent =
    percent &&
    new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 1,
    }).format(percent)

  return (
    <div
      className={clsx(s.wrapper, {
        [s.active]: isActive,
      })}
    >
      <div className={s.topWrapper}>
        <div className={s.title}>
          <div className={s.dot} />
          {title}
          {!!change && <PercentChange change={change} />}
        </div>
        <div className={s.right}>
          <div className={s.metric}>{formattedValue}</div> ({formattedPercent}%)
        </div>
      </div>
      <div className={s.progress}>
        <div
          className={s.innerProgress}
          style={{
            width: `${100 - (percent ?? 0)}%`,
          }}
        />
      </div>
    </div>
  )
}

export default StatProgress
